import { SiteCard } from './mapCoveoResultToCard.types';

export const formatMarkerTooltip = (site: SiteCard, template?: string): string => {
  const count = site.recruitingNowCount ?? 0;
  const distance =
    typeof site.distanceMiles === 'number' ? `${site.distanceMiles.toFixed(1)} mi` : '';

  if (template?.trim()) {
    return template.replace(/\{count\}/g, String(count)).replace(/\{distance\}/g, distance);
  }

  const enrollingLabel = count === 1 ? 'trial enrolling' : 'trials enrolling';
  if (distance) {
    return `${count} ${enrollingLabel} · ${distance}`;
  }

  return `${count} ${enrollingLabel}`;
};
